import React, { Component } from 'react'
import DrImg from 'app/images/Dr.R.svg'
import Text from 'app/images/text.svg'

import './index.css'

export default class MainContent extends Component {
  render() {
    return (
      <div>
        <div className='imgArea'>
          <div className='imgWrap'>
            <img className='text' src={Text} alt='' />
          </div>
        </div>
        <div className='contentArea' id='service'>
          <div>
            <img src={DrImg} alt=''/>
          </div>
          <div className='contentIntro'>
            <p className='title'>Dr.R  医患迅联连接您的未来</p>
            <p className='content'>嘉云升科技为中国400余家辅助生殖中心与每年百万对辅助生殖就诊夫妻提供高质量的体验和服务。公司由中国辅助生殖技术服务领军企业背书，整合领域全产业链资源，为医院与就诊人提供孕育全生命周期服务。</p>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/MainContent/index.js